// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3nnZ-","left":"StickyBox_left__1KvBN","right":"StickyBox_right__63IsO"};